<angular-editor #htmleditor [placeholder]="placeholder" (ngModelChange)="ngOnChanges($event)" [(ngModel)]="content" class="html-editor-container editor"
  [config]="editorConfig"></angular-editor>